import React, { createContext, useState } from 'react';

const ImageFileContext = createContext();
export default ImageFileContext;

const { Provider } = ImageFileContext;

const ImageFileProvider = (props) => {
  const [ultraList, setUltraList] = useState([]);
  const [ultraPreviewList, setUltraPreviewList] = useState([]);
  const [reviewList, setReviewList] = useState([]);
  const [reviewPreviewList, setReviewPreviewList] = useState([]);

  const context = {
    state: {
      ultraList,
      ultraPreviewList,
      reviewList,
      reviewPreviewList,
    },
    actions: {
      setUltraList,
      setUltraPreviewList,
      setReviewList,
      setReviewPreviewList,
    },
  };

  return <Provider value={context}>{props.children}</Provider>;
};

export { ImageFileProvider };
